export const types = {
  SET_DISTRIBUTORS: "SET_DISTRIBUTORS",
  CREATE_DISTRIBUTOR: "CREATE_DISTRIBUTOR",
  UPDATE_DISTRIBUTOR: "UPDATE_DISTRIBUTOR",
  DELETE_DISTRIBUTOR: "DELETE_DISTRIBUTOR",
};
